import {
  Button,
  Card,
  CrudMode,
  GeneralValidationErrors,
  Stack,
  Typography,
  ValidationErrors,
} from "@compass/core";
import {
  Permission,
  PermissionAction,
  StudentServiceSubType,
  StudentServiceSubTypeEditResource,
  StudentServiceSubTypeViewResource,
  TestLevel,
  TestLevelEditResource,
  TestLevelViewResource,
  TestType,
} from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { isAuthorized } from "services";
import { initDataModel } from "utils";
import { TestLevel as TestLevelEditor } from "./TestLevel";

export const TestLevels = (props: {
  rootPermission: Permission;
  crudMode: CrudMode;
  testType: TestType;
  testLevels: TestLevel[];
  setTestLevels: (value: TestLevel[]) => void;
  validationErrors: ValidationErrors | string[];
  generalValidationErrors: ValidationErrors | string[];
  onEdit: () => void;
}) => {
  const [viewResource, setViewResource] = useState<TestLevelViewResource>({});
  const [editResource, setEditResource] = useState<TestLevelEditResource>({});

  useEffect(() => {
    ApiService.testLevels.getViewResource().then((response) => setViewResource(response));
    ApiService.testLevels.getEditResource().then((response) => setEditResource(response));
  }, []);

  return (
    <Stack spacing="md">
      <Stack direction="row" alignItems="center" justifyContent={"space-between"}>
        <Stack>
          <Typography variant="h6" fontWeight={(theme) => theme.typography.fontWeightRegular}>
            Test Levels
          </Typography>
          <Stack>
            <GeneralValidationErrors errors={props.generalValidationErrors} />
          </Stack>
        </Stack>

        {isAuthorized(props.rootPermission, PermissionAction.Create) && (
          <Button
            onClick={() =>
              props.setTestLevels(
                produce(props.testLevels, (draft) => {
                  draft.unshift(initDataModel<TestLevel>({ testTypeId: props.testType.id }));
                  props.onEdit();
                })
              )
            }
            variant="outlined"
          >
            + New
          </Button>
        )}
      </Stack>

      {props.testLevels.map((testLevel, index) => (
        <TestLevelEditor
          rootPermission={props.rootPermission}
          testLevel={testLevel}
          setTestLevel={(value) => {
            props.setTestLevels(
              produce(props.testLevels, (draft) => {
                draft[index] = value;
              })
            );
            props.onEdit();
          }}
          cancelCreate={() =>
            props.setTestLevels(
              produce(props.testLevels, (draft) => {
                draft.splice(index, 1);
              })
            )
          }
          viewResource={viewResource}
          editResource={editResource}
          validationErrors={props.validationErrors[index] || []}
        />
      ))}

      {props.testLevels.length === 0 && (
        <Card>
          <Typography>No Test Levels</Typography>
        </Card>
      )}
    </Stack>
  );
};
